export default {
  hasZenMode: state => state.zenMode,
  activityList: state => state.activityList,
  attendanceList: state => state.attendanceList,
  loading: state => state.loading,
  loadingDialog: state => state.loadingDialog,
  search: state => state.search,
  recordsList: state => state.recordsList,
  error: state => state.error,
  getSnackbarState: state => state.showSnackbar,
  getSnackbarText: state => state.snackbarText
};
